'use client';

import Link from 'next/link';
import { useLocale } from 'next-intl';

export default function NotFound() {
  const locale = useLocale();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <h1 className="text-4xl font-bold mb-4">404</h1>
      <p className="text-xl mb-8">Page not found</p>
      <Link
        href={`/${locale}`}
        className="px-6 py-3 bg-[#EAAC00] text-black rounded-lg hover:opacity-90"
      >
        Go Home
      </Link>
    </div>
  );
}
